import { useState } from 'react'
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap'
import { useAddPeopleCountMutation } from '../../../../APIS'

const AddPeopleCountModal = ({ show, onHide }) => {
  const [date, setDate] = useState('')
  const [peopleCount, setPeopleCount] = useState('')
  const [error, setError] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const mutation = useAddPeopleCountMutation()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccessMessage('')

    // Validation
    if (!date || !peopleCount) {
      setError('Please fill in all fields')
      return
    }

    const count = parseInt(peopleCount)
    if (isNaN(count) || count < 0) {
      setError('Please enter a valid people count')
      return
    }

    try {
      await mutation.mutateAsync({ date, peopleCount: count })
      setSuccessMessage('People count added successfully!')
      
      // Reset form and close modal after success
      setTimeout(() => {
        setDate('')
        setPeopleCount('')
        setSuccessMessage('')
        onHide()
      }, 1500)
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to add people count. Please try again.')
    }
  }

  const handleClose = () => {
    setDate('')
    setPeopleCount('')
    setError('')
    setSuccessMessage('')
    onHide()
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add People Count</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant='danger' className='mb-3'>{error}</Alert>}
        {successMessage && <Alert variant='success' className='mb-3'>{successMessage}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label>Date</Form.Label>
            <Form.Control
              type='date'
              value={date}
              onChange={(e) => setDate(e.target.value)}
              disabled={mutation.isPending}
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>People Count</Form.Label>
            <Form.Control
              type='number'
              placeholder='Enter number of people'
              value={peopleCount}
              onChange={(e) => setPeopleCount(e.target.value)}
              min='0'
              disabled={mutation.isPending}
            />
          </Form.Group>

          <div className='d-flex gap-2'>
            <Button
              variant='primary'
              type='submit'
              disabled={mutation.isPending}
              className='flex-grow-1'
            >
              {mutation.isPending ? (
                <>
                  <Spinner size='sm' className='me-2' animation='border' />
                  Adding...
                </>
              ) : (
                'Add People Count'
              )}
            </Button>
            <Button variant='secondary' onClick={handleClose} disabled={mutation.isPending}>
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default AddPeopleCountModal
